import React from 'react'

export const ErrorMessage = ({children, className}: {children: React.ReactNode, className?: string}) => {
    return (
        <p className={`text-pink_drink text-xs text-left px-9 ${className ?? null}`}>
            {children}
        </p>
    )
}